import AtendeOutlined from "./atende-outlined.inline.svg";
import EDLOutlined from "./edl-outlined.inline.svg";
import RocketOutlined from "./rocket-outlined.inline.svg";
import ShineOutlined from "./shine-outlined.inline.svg";
import GreenEvoOutlined from "./greenevo-outlined.inline.svg";
import AwardOutlined from "./award-outlined.inline.svg";

import ShineOutlinedSmall from "./shine-outlined-small.inline.svg";
import Number01 from "./number-01.inline.svg";
import Number02 from "./number-02.inline.svg";
import Number03 from "./number-03.inline.svg";
import Number04 from "./number-04.inline.svg";
import Number05 from "./number-05.inline.svg";
import Handshake from "./handshake.inline.svg";

export default {
  AtendeOutlined,
  EDLOutlined,
  RocketOutlined,
  ShineOutlined,
  GreenEvoOutlined,
  AwardOutlined,
  ShineOutlinedSmall,
  Number01,
  Number02,
  Number03,
  Number04,
  Number05,
  Handshake,
};
